// ScrollFadeIn.tsx
import React, { useRef, useState, useEffect } from "react";

interface Props {
  children: React.ReactNode;
  threshold?: number;
  className?: string;
}

const ScrollFadeIn: React.FC<Props> = ({ children, threshold = 0.3, className = "" }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold,
      }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [threshold]);

  return (
    <div
      ref={ref}
      className={`${className} scroll-fade ${isVisible ? "visible" : ""}`}
    >
      {children}
    </div>
  );
};

export default ScrollFadeIn;
